import React from 'react'
import {Control, Errors} from 'react-redux-form'
import ArrowButton from '../../../common/button-arrow'
import {Row, Col, FormGroup, FormControl} from 'react-bootstrap'

const AutoLoadDate = ({index, onDelete}) => {
  return (
    <div>

      <Row>
        <Col lg={12} className="autoload-date-col">
          <FormGroup>
            <Control
              model={`.autoload_dates[${index}]`}
              placeholder="dd/mm"
              pattern="\d\d/\d\d"
              component={FormControl}/>

            <Errors
              show={{
                touched: true,
                focus: false
              }}
              className="errors"
              model={`.autoload_dates[${index}]`}
              messages={{
                patternMismatch: 'Value does not match the required pattern'
              }}/>
          </FormGroup>

          <ArrowButton submit={false}
                       arrow={false}
                       onClick={() => onDelete(index)}>Delete</ArrowButton>

        </Col>
      </Row>
    </div>
  )
};

export default AutoLoadDate


// WEBPACK FOOTER //
// ./src/components/admin/ppc/settings/autoload-date.jsx